import type { KeyboardEvent as ReactKeyboardEvent } from 'react'

export const onKeyDownHandler = (
  event: KeyboardEvent | ReactKeyboardEvent,
  callback: () => void
) => {
  if (event.key === ' ' || event.key === 'Spacebar' || event.key === 'Enter') {
    event.preventDefault()
    callback()
  }
}

export const buttonsHandler = () => {
  const buttons = document.querySelectorAll('button, a')

  buttons.forEach(function (button: Element) {
    const htmlButton = button as HTMLButtonElement | HTMLAnchorElement
    htmlButton.setAttribute('tabindex', '0')

    htmlButton.onkeydown = function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        ;(this as HTMLElement).click()
      }
    }
  })
}

const focusInputAfterFlag = () => {
  const flagContainer = document.querySelector('.iti__flag-container') as HTMLElement
  const inputContainer = flagContainer.nextElementSibling as HTMLInputElement

  if (inputContainer) {
    inputContainer.focus()
  }
}

let visibleCountries: HTMLElement[] = []

const recomputeVisibleCountries = (allCountries: HTMLElement[]) => {
  const visible = allCountries.filter((el) => getComputedStyle(el).display === 'block')
  visibleCountries = visible.length ? visible : allCountries
}

const onSelectInputKeyDown = (event: KeyboardEvent, allCountries: HTMLElement[]) => {
  if (event.key === 'ArrowDown') {
    event.preventDefault()
    recomputeVisibleCountries(allCountries)
    visibleCountries[0]?.focus()
  }

  if (event.key === 'ArrowUp') {
    event.preventDefault()
    recomputeVisibleCountries(allCountries)
    visibleCountries[visibleCountries.length - 1]?.focus()
  }
}

const onCountryListKeyDown = (
  event: KeyboardEvent,
  selectInput: HTMLElement,
  countryList: HTMLElement,
  allCountries: HTMLElement[]
) => {
  const target = event.target as HTMLElement
  if (!target.classList.contains('iti__country')) return

  recomputeVisibleCountries(allCountries)
  const index = visibleCountries.indexOf(target)
  if (index === -1) return

  switch (event.key) {
    case 'ArrowDown':
      event.preventDefault()
      visibleCountries[index + 1]?.focus()
      break

    case 'ArrowUp':
      event.preventDefault()
      visibleCountries[index - 1]?.focus()
      break

    case 'Enter':
    case ' ':
      event.preventDefault()
      target.click()
      countryList.classList.add('iti__hide')
      focusInputAfterFlag()
      break

    case 'Escape':
      event.preventDefault()
      selectInput.focus()
      break
  }
}

let selectInputKeyDownHandler: ((e: KeyboardEvent) => void) | null = null
let countryListKeyDownHandler: ((e: KeyboardEvent) => void) | null = null
let inputHandler: (() => void) | null = null

/**
 * Assumes a single dial number selector per page.
 * This handler is initialized once and not intended for re-mounting.
 */
export const dialNumberSelectorHandler = () => {
  const selectInput = document.querySelector('.iti__countrylist__input') as HTMLElement
  const countryList = document.querySelector('.iti__country-list') as HTMLElement

  if (!selectInput || !countryList) return

  const allCountries = Array.from(countryList.querySelectorAll<HTMLElement>('.iti__country'))

  allCountries.forEach((el) => (el.tabIndex = 0))

  if (!inputHandler) {
    inputHandler = () => recomputeVisibleCountries(allCountries)
  }

  if (!selectInputKeyDownHandler) {
    selectInputKeyDownHandler = (event) => onSelectInputKeyDown(event, allCountries)
  }

  if (!countryListKeyDownHandler) {
    countryListKeyDownHandler = (event) =>
      onCountryListKeyDown(event, selectInput, countryList, allCountries)
  }

  // safe re-init
  selectInput.removeEventListener('input', inputHandler)
  selectInput.removeEventListener('keydown', selectInputKeyDownHandler)
  countryList.removeEventListener('keydown', countryListKeyDownHandler)

  selectInput.addEventListener('input', inputHandler)
  selectInput.addEventListener('keydown', selectInputKeyDownHandler)
  countryList.addEventListener('keydown', countryListKeyDownHandler)
}
